import { useEffect, useState } from 'react'

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>
}

function isStandaloneDisplay() {
  return window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true
}

export function PwaInstallHint() {
  const [installEvent, setInstallEvent] = useState<BeforeInstallPromptEvent | null>(null)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || isStandaloneDisplay()) {
      return
    }

    const handleBeforeInstallPrompt = (event: Event) => {
      event.preventDefault()
      setInstallEvent(event as BeforeInstallPromptEvent)
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    }
  }, [])

  if (!installEvent || dismissed) {
    return null
  }

  const installApp = async () => {
    await installEvent.prompt()
    await installEvent.userChoice
    setInstallEvent(null)
  }

  return (
    <aside className="pwa-install-hint" aria-label="Install SGS Fee Portal">
      <div>
        <strong>Install SGS Fee Portal</strong>
        <p>Use the portal like an app on this phone or computer.</p>
      </div>
      <div className="pwa-install-actions">
        <button className="button button-small" type="button" onClick={installApp}>
          Install
        </button>
        <button
          className="button button-secondary button-small"
          type="button"
          onClick={() => setDismissed(true)}
        >
          Not now
        </button>
      </div>
    </aside>
  )
}
